module.exports = __webpack_public_path__ + "img/bg_login.83056f5d.png";